import React from 'react';
import { Flex, Box, Title, Badge, Text, Button } from '@mantine/core';
import { PiEnvelope } from 'react-icons/pi';
import dayjs from 'dayjs';

export const DashboardHeader = ({ onSendReport, loading }) => (
  <Flex justify="space-between" align="center" mb="lg" px="md">
    <Box>
      <Title order={ 1 } c="dark.5">NOC Dashboard</Title>
      <Group gap="xs">
        <Badge variant="dot" color="yellow" size="lg" className="animate-pulse">
          SISTEMA OPERATIVO
        </Badge>
        <Text c="dimmed" size="sm" fw={500}>Monitor de red y servicios en tiempo real</Text>
      </Group>
    </Box>

    <Button
      variant="filled"
      leftSection={ <PiEnvelope size={ 18 } /> }
      onClick={ onSendReport }
      loading={ loading }
      size="sm"
    >
      GENERAR REPORTE
    </Button>
  </Flex>
);

export const SectionTitle = ({ title }) => (
  <Text size="xs" fw={800} c="dimmed" mb="md" px="md" tt="uppercase" className="tracking-widest">
    {title}
  </Text>
);

const Group = ({ children, ...props }) => (
  <Flex align="center" gap="xs" {...props}>
    {children}
  </Flex>
);
